import { Toolbar } from 'common/ProseInput/components/Toolbar'
import { Button } from 'components/Button'
import { useCollabItemContext } from 'components/CollabItem/CollabItem'
import { CommentForm } from 'components/CommentForm/CommentForm'
import { useUpdateTrackedChangeComment } from 'hooks/queries/trackedChangeComments/useUpdateTrackedChangeComment'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { TrackedChangeCommentItemEditFormProps } from './Types'
import Styles from './TrackedChangeCommentItemEditForm.module.scss'

const TrackedChangeCommentItemEditForm = observer(
  ({ comment, layerId, articleKey }: TrackedChangeCommentItemEditFormProps) => {
    const { setEditing } = useCollabItemContext()
    const isRichText = useFlipperFlag('richtext_comments')
    const [newValue, setNewValue] = useState(isRichText && comment.html_body ? comment.html_body : comment.body)

    const { mutate: updateComment } = useUpdateTrackedChangeComment({
      articleKey,
      layerId,
      trackedChangeId: comment.tracked_change_id,
      id: comment.id,
      isRichText,
    })

    const handleSubmit = async () => {
      setEditing(undefined)
      updateComment({ body: newValue })
    }

    useEffect(() => {
      if (isRichText && comment.html_body) {
        setNewValue(comment.html_body)
      }
    }, [isRichText, comment.html_body])

    return (
      <CommentForm
        autoFocus
        value={newValue}
        onChange={setNewValue}
        onSubmit={handleSubmit}
        onCancel={() => setEditing(undefined)}
        showAvatar={false}
        primaryCta={<Button>Update</Button>}
        isHtmlComment={isRichText}
        inputContainerClassName={Styles.inputContainer}
        footer={
          isRichText && (
            <Toolbar.Root>
              <Toolbar.Bold />
              <Toolbar.BulletList />
              <Toolbar.Mention />
            </Toolbar.Root>
          )
        }
      />
    )
  },
)

export { TrackedChangeCommentItemEditForm }
